'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaGetPocket = function FaGetPocket(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.9 2.9q1.5 0 2.5 1t1 2.4v11.6q0 4-1.5 7.5t-4.1 6.2-6.1 4-7.5 1.5q-3.9 0-7.5-1.5t-6.1-4-4.1-6.2-1.5-7.5v-11.6q0-1.4 1-2.4t2.5-1h31.4z m-15.7 23.7q1.1 0 1.8-0.7l9.1-8.7q0.8-0.8 0.8-1.9 0-1.1-0.8-1.9t-1.8-0.7q-1.1 0-1.9 0.7l-7.2 6.9-7.2-6.9q-0.8-0.7-1.8-0.7-1.1 0-1.9 0.7t-0.7 1.9q0 1.2 0.8 1.9l9 8.7q0.7 0.7 1.8 0.7z' })
        )
    );
};

exports.default = FaGetPocket;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/get-pocket.js
// module id = 330
// module chunks = 61762850755587 79611799117203 213534597649335